import { ButtonDropdown, Icon, Tag } from '@bitcine/cinesend-theme/dist'
import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

const CycleDropdown = ({ airlineID, cycleID, setCycle }) => {
  const { data: cycles, isLoading } = useQuery(['cycles', `?airlineID=${airlineID}`])
  const cycle = cycles?.find((cycle) => cycle.id === cycleID)

  useEffect(() => {
    if (!isLoading && !cycle) {
      setCycle(null)
    }
  }, [isLoading, cycle])

  if (isLoading) {
    return null
  }

  return (
    <ButtonDropdown
      button={{
        component: (
          <div className='w-56 justify-between space-x-1 text-xs flex items-center rounded bg-primary-700 hover:bg-primary-600 px-2'>
            <Icon icon='date_range' className='text-xl text-white flex-none' />
            <span className='text-xs text-gray-200'>{cycle ? (cycle.name ?? cycle.description) : 'Select cycle'}</span>
            {cycle && <Tag type='info' label={cycle.status_label} size='small' />}
            <Icon icon='arrow_drop_down' className='text-xl text-white flex-none' />
          </div>
        ),
      }}
      dropdown={{
        content: cycles?.map((cycle) => ({
          icon: cycle.id === cycleID ? 'check_circle' : 'more_horiz',
          className: cycle.id === cycleID ? 'text-green-600' : 'text-gray-500',
          text: `${cycle.name ?? cycle.description} (${cycle.status_label})`,
          onClick: () => setCycle(cycle.id),
        })),
      }}
    />
  )
}

export default CycleDropdown
